import { Link, useLocation } from "react-router-dom";

const PUBLIC_REPORT_HOME = "https://kittylaunch.com/reportgen";

export function BrandMark({ size = 34, className = "brand-mark" }: { size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" focusable="false">
      <path d="M18 0H42L64 22V46A18 18 0 0 1 46 64H18A18 18 0 0 1 0 46V18A18 18 0 0 1 18 0Z" fill="#111113" />
      <path className="brand-mark-edge" d="M18 1.25H41.48L62.75 22.52V46A16.75 16.75 0 0 1 46 62.75H18A16.75 16.75 0 0 1 1.25 46V18A16.75 16.75 0 0 1 18 1.25Z" fill="none" stroke="#fff" strokeOpacity=".12" strokeWidth="1.5" />
      <path d="M42 0L64 22H48A6 6 0 0 1 42 16Z" fill="#ff5b24" />
      <path d="M21 17V47M39 18L25.5 32L40 47" fill="none" stroke="#fff" strokeWidth="6.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function Brand({ compact = false }: { compact?: boolean }) {
  const { pathname } = useLocation();
  const content = (
    <>
      <BrandMark />
      {!compact && (
        <span className="brand-copy">
          <strong>ReportGen</strong>
          <small>by KittyLaunch</small>
        </span>
      )}
    </>
  );

  if (pathname === "/admin" || pathname.startsWith("/admin/")) {
    return (
      <Link to="/admin" className="brand" aria-label="ReportGen by KittyLaunch admin home">
        {content}
      </Link>
    );
  }

  return (
    <a href={PUBLIC_REPORT_HOME} className="brand" aria-label="ReportGen by KittyLaunch home">
      {content}
    </a>
  );
}
